import React, { useMemo } from "react";

import Highlighter from "react-highlight-words";

import styles from "./TextHighlighter.module.scss";

interface TextHighlighterProps {
  autoEscape?: boolean;
  className?: string;
  searchText: string | string[];
  text: string;
}

const TextHighlighter = ({
  autoEscape = true,
  className,
  searchText,
  text,
}: TextHighlighterProps) => {
  const searchWords = useMemo(() => {
    return (Array.isArray(searchText) ? searchText : [searchText]).map((searchText) =>
      searchText.trim()
    );
  }, [searchText]);

  return (
    <Highlighter
      autoEscape={autoEscape}
      className={className}
      highlightClassName={styles.highlight}
      searchWords={searchWords}
      textToHighlight={text}
    />
  );
};

export default TextHighlighter;
